<template>
  <SogPage
    id="page"
  >
    <SogCard>
      <SogCardTitle>
        Schaden melden
        <template #SubTitle>
          Claims Notification
        </template>
      </SogCardTitle>
      <SogCardContent>
        Melden Sie hier ganz einfach Ihren Schaden.<br>
        Simply report your claim here.
      </SogCardContent>
      <SogCardContent>
        <SogFlexRow>
          <SogCard>
            <SogCardTitle>
              Phone
            </SogCardTitle>
            <SogCardContent>
              <SogIcon icon="mdi-phone-classic" />
              {{ _telephone }}
            </SogCardContent>
            <SogCardActions v-show="mobile">
              <SogCardActionButton
                mdi-icon="mdi-phone-classic"
                @click="onPhone"
              />
            </SogCardActions>
          </SogCard>
          <SogCard v-show="!_is2025">
            <SogCardTitle>
              Online
            </SogCardTitle>
            <SogCardContent>Sie werden an den Schadendienstleister weitergeleitet.</SogCardContent>
            <SogCardActions>
              <SogCardActionButton
                mdi-icon="mdi-web"
                @click="onWeb"
              />
            </SogCardActions>
          </SogCard>
          <SogCard>
            <SogCardTitle>
              E-mail
            </SogCardTitle>
            <SogCardContent>
              {{ _email }}
            </SogCardContent>
            <SogCardActions>
              <SogCardActionButton
                mdi-icon="mdi-at"
                @click="onEmail"
              />
            </SogCardActions>
          </SogCard>
        </SogFlexRow>
      </SogCardContent>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import {computed, ref} from "vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogIcon from "@/shared/ui/SogIcon.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import {useRouter} from "vue-router";
import {useDisplay} from "vuetify";
const {mobile} = useDisplay()


const _title = ref("Schaden melden")

const _router = useRouter()


function onWeb() {
  _router.push("/schadenonline")
}

function onEmail() {
  window.location.replace(_is2025.value?"mailto:agent22.schaden@avus-group.com":"mailto:agent22.schaden@vanameyde.com")
}

function onPhone() {
  window.location.replace(_is2025.value?"tel:+494076465099":"tel:+4922195420689")
}

const _is2025 = computed(()=>{
  return new Date()>=new Date(2025,0,1);
})

const _telephone = computed(()=>{
  return _is2025.value?" +49 40 76465099":" +49 221 95420689"
})

const _email = computed(()=>{
  return _is2025.value?"agent22.schaden(at)avus-group.com":"agent22.schaden(at)vanameyde.com"
})

</script>
<style scoped>
</style>
